import React from 'react';
import PropTypes from 'prop-types';
// import { generateAppPath } from 'epic-common/src/route';

class SocialBlock extends React.Component {
    static propTypes = {
        socialLink: PropTypes.object
    }

    render() {
        const {socialLink} = this.props;

        return (
            <section className="homeViewSocial">
                <div className="grid">
                    <div className="copy">
                        <h5>{socialLink.socialTitle}</h5>
                        <ul>
                            <li>
                                <a href={socialLink.facebook} target="_blank" rel="noopener noreferrer">
                                    <i className="fa fa-facebook" />
                                </a>
                            </li>
                            <li>
                                <a href={socialLink.youtube} target="_blank" rel="noopener noreferrer">
                                    <i className="fa fa-youtube" />
                                </a>
                            </li>
                            <li>
                                <a href={socialLink.instagram} target="_blank" rel="noopener noreferrer">
                                    <i className="fa fa-instagram" />
                                </a>
                            </li>
                            <li>
                                <a href={socialLink.twitter} target="_blank" rel="noopener noreferrer">
                                    <i className="fa fa-twitter" />
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </section>
        );
    }
}

export default SocialBlock;
